/**
 * MobX React Alias
 * 用于替换 mobx-react 的 inject，支持动态加载 Mod
 *
 * 通过 Webpack alias 配置，将 'mobx-react' 指向这个文件
 * 这样业务代码中的 import { inject } from 'mobx-react' 会自动使用我们的版本
 */

// 通过 webpack alias 'mobx-react-original' 导入真实的 mobx-react，绕过 'mobx-react$' 的 alias 避免循环引用
import React from 'react';
import * as OriginalMobxReact from 'mobx-react-original';
import { getStoreSnapshot, subscribeStoreRegistry } from './runtimeStoreRegistry';

// 重新导出所有内容（除了 inject）
export const observer = OriginalMobxReact.observer;
export const Observer = OriginalMobxReact.Observer;
export const useLocalObservable = OriginalMobxReact.useLocalObservable;
export const useAsObservableSource = OriginalMobxReact.useAsObservableSource;
export const useObserver = OriginalMobxReact.useObserver;
export const isUsingStaticRendering = OriginalMobxReact.isUsingStaticRendering;
export const useStaticRendering = OriginalMobxReact.useStaticRendering;
export const enableStaticRendering = OriginalMobxReact.enableStaticRendering;
export const observerBatching = OriginalMobxReact.observerBatching;
export const isObserverBatched = OriginalMobxReact.isObserverBatched;
export const MobXProviderContext = OriginalMobxReact.MobXProviderContext;
export const disposeOnUnmount = OriginalMobxReact.disposeOnUnmount;
export const PropTypes = OriginalMobxReact.PropTypes;

export function Provider({ children, ...stores }) {
  const [version, forceUpdate] = React.useReducer((value) => value + 1, 0);

  React.useEffect(() => subscribeStoreRegistry(() => forceUpdate()), []);

  // stores 里的值都是 MobX 单例，不会换引用。
  // 用 ref 固定住，避免解构每次产生新对象导致 useMemo 无效
  const storesRef = React.useRef(stores);

  const contextValue = React.useMemo(() => {
    const runtimeStores = getStoreSnapshot();
    return {
      ...storesRef.current,
      ...runtimeStores
    };
  }, [version]); // 只在 runtimeStores 变化（新 Mod 加载）时重算

  return <MobXProviderContext.Provider value={contextValue}>{children}</MobXProviderContext.Provider>;
}

// 覆盖 inject，使用基于 ModuleMap 的动态加载版本
export { dynamicInject as inject } from './dynamicInject';



// WEBPACK FOOTER //
// ./src/utils/storeRuntime/mobxReactAlias.js